import React from "react";

const SvgCheckbox = props => <svg viewBox="0 0 8 6" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M6.293.293L3 3.586 1.707 2.293A.999.999 0 1 0 .293 3.707l2 2a.997.997 0 0 0 1.414 0l4-4A.999.999 0 1 0 6.293.293" fill="#603276" /></svg>;

export default SvgCheckbox;